// RemoteApply (funnel 35) design tokens, mirrored from the page-builder
// "remoteapply" project so the React pages match the prototypes 1:1.
export const RA_INK = '#16202E';
export const RA_BLUE = '#2563EB';
export const RA_GREEN = '#19B361';
export const RA_GREEN_INK = '#0F8A48';
export const RA_GRAY_600 = '#5A5A5A';
export const RA_GRAY_500 = '#8A8A8A';

export const RA_PAGE_BG = 'linear-gradient(180deg, #F5F8FF 0%, #DCE6FF 100%)';
export const RA_PAGE_BG_REVERSE = 'linear-gradient(0deg, #F5F8FF 0%, #DCE6FF 100%)';
export const RA_HERO_BG = 'linear-gradient(180deg, #F6F9FF 0%, #D2E0FD 100%)';

// Primary CTA used across landing, quiz, email gate and summary.
export const RA_BUTTON_CLASS =
  'inline-flex items-center justify-center rounded-full bg-[#111] text-white font-bold transition hover:brightness-110 active:scale-[0.98] disabled:opacity-35 disabled:cursor-not-allowed disabled:hover:brightness-100';
